const saveQuoteMessage = (saveType, email) => {
  const messageObj = {
    initial: {
      title: "",
      message: "",
    },
    success: {
      title: "",
      message: "",
    }
  }
  switch(saveType) {
    case "timeout":
      messageObj.initial.title = "Before you go";
      messageObj.initial.message = "Save your quote information by entering your email address below to receive a link to your quote";
      messageObj.success.title = "We sent you a link!";
      messageObj.success.message = `Your saved quote was sent to ${email}.`;
      break;
    case "update":
      messageObj.initial.title = "Update your saved quote";
      messageObj.initial.message = "It looks like you already saved a quote. Would you like to update it to the current results?";
      messageObj.success.title = "Updated!";
      messageObj.success.message = "Your saved quote was updated.";
      break;
    default:
      messageObj.initial.title = "Save your quote";
      messageObj.initial.message = "Please enter your email address below so we can send you a link and save all your quote information.";
      messageObj.success.title = "We sent you a link!";
      messageObj.success.message = `Your saved quote was sent to ${email}.`;
    break;
  }

  return messageObj;
}

export { saveQuoteMessage };


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/SaveTermQuote/SaveQouteMessage.js